import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const PartnerCompanies = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:PartnerCompany",
    read: "read:PartnerCompany",
    list: "list:PartnerCompany",
    update: "update:PartnerCompany",
    delete: "delete:PartnerCompany",
  },
};
